<template>
  <div class="container">
    <main class="main">
      <div v-for="story in stories" class="question" :key="story.id" @click="start(story.id)">
        <p>{{ story.title }}</p>
        <span><i class="icon-walk"/></span>
        <img v-if="history.includes(story.id)" src="@/assets/images/check_on.png"/>
        <img v-else src="@/assets/images/check_off.png"/>
      </div>
    </main>
    <v-button class="stop" icon="check" :label="`stoppen met ${character.name}`" primary large @click="stop"/>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import AudioPlayer from '@/AudioPlayer'
import Button from '@/components/Button'
import { defer } from '@/utils'
import characters from '@/data/characters'
import stories from '@/data/stories'

export default {
  name: 'SelectStoryView',
  components: {
    'v-button': Button
  },
  computed: {
    ...mapState({
      history: state => state.history,
      character: state => characters.find(character => character.name === state.character)
    }),
    stories () {
      return stories.filter(story => this.character.stories.includes(story.id))
    }
  },
  methods: {
    ...mapActions([
      'loadScene',
      'loadStory'
    ]),
    stop () {
      defer(100, () => this.loadScene({ name: 'SelectCharacter' }))
    },
    start (id) {
      defer(100, () => this.loadStory(id))
    }
  },
  mounted () {
    defer(1200, () => {
      const { character, history } = this
      const n = history.filter(id => character.stories.includes(id)).length
      const intro = n > 1 ? 'intro3' : `intro${n + 1}`
      AudioPlayer.load(`audio/characters/${character.name}/${intro}.mp3`).play()
    })
  }
}
</script>

<style scoped lang="scss">
.container {
  position: relative;
  display: flex;
  width: 100%;
  height: 100%;
  padding: 3rem;
  align-items: flex-end;
  @include fade-in(400ms, 2s);
}

.stop {
  position: fixed;
  bottom: 3rem;
  right: 3rem;
}

.main {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-bottom: 4.5rem;
}

.question {
  @include clickable();
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  width: 100%;
  max-width: 18rem;
  height: 12rem;
  margin: 0 1.5rem;
  padding: 0 1.5rem;
  text-align: center;
  background-color: $color-white;
  transition: background-color 200ms, transform 50ms;

  p {
    margin: 0;
    font-size: $text-lg;
    font-weight: 500;
  }

  span {
    display: inline-block;
    position: absolute;
    bottom: 0;
    left: 50%;
    width: 4.8rem;
    height: 4.8rem;
    border-radius: 50%;
    border: 0.2rem solid $color-orange;
    background-color: $color-white;
    color: $color-black;
    font-size: 3rem;
    line-height: 4.8rem;
    transform: translate(-50%, 50%)
  }

  img {
    width: 2.4rem;
    position: absolute;
    top: 0;
    right: 0;
  }

  &:active {
    transform: scale(.98);
  }
}
</style>
